import "./companies.list"
import "./companies.edit"
import "./orders.edit"
import "./orders.list"


$('[data-entity="manager-login"]').inputmask({
  "mask": "+7 (!99) 999-9999",
  definitions: {
    '!': {
      validator: "[0-6,9]"
    }
  },
  'autoUnmask': false,
  "oncomplete": function (arg, arg2) {
    // _self.onComplete();
    // _self.passwordGroup.removeClass('hide');
    // _self.applyButton.attr('disabled', false);
    // if (_self.completeSemaphore){
    //   _self.bindResendAtteniton();
    //   _self.completeSemaphore = false;
    // }
  },
  "onincomplete": function (arg, arg2) {
    // if (!_self.passwordGroup.hasClass('hide')) {
    //   _self.removeSenderBlock();
    // }
  },
  "oncleared": function () {
    // if (!_self.passwordGroup.hasClass('hide')) {
    //   _self.removeSenderBlock();
    // }
  }
});
